<i class="{{ iconStyle }}" [ngClass]="icon || 'sctr-icon-check-circle-broken'"></i>
<span [tooltip]="this.text" [theme]="theme" [isTruncated]="true" [position]="position" class="{{ textStyle }}">{{ this.text | translate }}</span>